import { render, staticRenderFns } from "./NoDistribution.vue?vue&type=template&id=6ca196af&"
import script from "./NoDistribution.vue?vue&type=script&lang=js&"
export * from "./NoDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports